<template>
	<div class="info-bar">
		<slot></slot>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'

	export default {
		name: 'InfoBar',
		methods: {
			...mapActions('system', ['ToggleInfoBar']),
		},
		mounted() {
			this.ToggleInfoBar(true)
		},
		beforeDestroy() {
			this.ToggleInfoBar(false)
		},
	}
</script>

<style lang="scss" scoped>
	.info-bar {
		color: var(--fontColorLighter);
	}
</style>
